import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const IndustriesSection = () => {
  const industries = [
    {
      name: "Restaurants",
      icon: "🍽️",
      description: "BellaBot Pro + Voice AI for delivery, bussing, and reservations",
      link: "/restaurants"
    },
    {
      name: "Hotels",
      icon: "🏨",
      description: "KettyBot Pro + CC1 Pro for guest service and spotless floors",
      link: "/hotels"
    },
    {
      name: "Healthcare",
      icon: "🏥",
      description: "CC1 Pro + T600 + HIPAA Voice AI for infection control",
      link: "/healthcare"
    },
    {
      name: "Warehouses",
      icon: "🏭",
      description: "Heavy-duty cleaning robots for safe, compliant operations",
      link: "/warehouses"
    },
    {
      name: "Education",
      icon: "🎓",
      description: "Autonomous cleaning for schools and universities",
      link: "/education"
    }
  ];

  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Industries We <span className="text-primary">Serve</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Tailored automation solutions for your industry's unique challenges.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {industries.map((industry) => (
          <Link
            key={industry.name}
            to={industry.link}
            className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-xl group"
          >
            <div className="text-5xl mb-4">{industry.icon}</div>
            <h3 className="font-orbitron font-bold text-xl mb-2 group-hover:text-primary transition-colors">
              {industry.name}
            </h3>
            <p className="text-sm text-muted-foreground mb-4">{industry.description}</p>
            <span className="text-primary font-bold text-sm">Learn more →</span>
          </Link>
        ))}

        <Link
          to="/case-studies"
          className="border border-primary/50 bg-primary/10 p-6 rounded-xl hover:bg-primary/20 transition-all duration-300 hover:scale-105 hover:shadow-xl group flex flex-col justify-center items-center text-center"
        >
          <div className="text-5xl mb-4">⭐</div>
          <h3 className="font-orbitron font-bold text-xl mb-2 group-hover:text-primary transition-colors">
            Success Stories
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            See real results from businesses like yours
          </p>
          <span className="text-primary font-bold text-sm">View case studies →</span>
        </Link>
      </div>
    </section>
  );
};

export default IndustriesSection;
